import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _sortBy from "lodash/sortBy";
export var groupFilters = function groupFilters(types) {
  var groupedFilters = {};
  var filters = types.filter(function (type) {
    var _type$validations$, _type$validations$$in;

    return ((_type$validations$ = type.validations[0]) === null || _type$validations$ === void 0 ? void 0 : (_type$validations$$in = _type$validations$["in"]) === null || _type$validations$$in === void 0 ? void 0 : _type$validations$$in.length) > 0;
  });
  filters.forEach(function (filter) {
    var _validations$0$in;

    var name = filter.name,
        validations = filter.validations,
        id = filter.id;
    groupedFilters[id] = {
      title: name,
      items: _sortBy((_validations$0$in = validations[0]["in"]) === null || _validations$0$in === void 0 ? void 0 : _validations$0$in.sort().map(function (item) {
        return {
          title: item,
          id: "".concat(item.toLowerCase().replace(/\s/g, ""))
        };
      }), function (item) {
        return item.title.toLowerCase();
      })
    };
  });
  return groupedFilters;
};

var determineDateStr = function determineDateStr(start, end) {
  var startMonth = start.toLocaleString("en-US", {
    month: "short"
  });
  var startDay = start.getDate();
  var endMonth = end === null || end === void 0 ? void 0 : end.toLocaleString("en-US", {
    month: "short"
  });
  var endDay = end === null || end === void 0 ? void 0 : end.getDate();
  var startYear = start.getFullYear();
  var endYear = end === null || end === void 0 ? void 0 : end.getFullYear();
  var isSameYear = startYear === endYear;
  var isSameMonth = startMonth === endMonth;
  var isSameDay = startDay === endDay;
  var isSameMonthAndYear = isSameMonth && isSameYear;
  var isSameMonthDayAndYear = isSameMonth && isSameDay && isSameYear;

  if (isSameMonthDayAndYear) {
    return "".concat(startMonth, ". ").concat(startDay, ", ").concat(startYear);
  }

  if (isSameMonthAndYear) {
    return "".concat(startMonth, ". ").concat(startDay, "-").concat(endDay, ", ").concat(startYear);
  }

  return "".concat(startMonth, ". ").concat(startDay, " - ").concat(endMonth, ". ").concat(endDay, ", ").concat(endYear);
};

export var toEventCard = function toEventCard(event) {
  var endDate = event.endDate,
      startDate = event.startDate,
      ctaText = event.ctaText,
      title = event.title,
      url = event.url,
      region = event.region,
      eventType = event.eventType,
      content = event.content;
  var eventStartDate = new Date(startDate);
  var eventEndDate = new Date(endDate || startDate);
  return {
    title: title,
    ctaText: ctaText,
    url: url,
    startDate: startDate,
    endDate: endDate || startDate,
    dateStr: determineDateStr(eventStartDate, eventEndDate),
    region: region,
    eventType: eventType,
    content: content
  };
};

var getTwoDigitMonth = function getTwoDigitMonth(month) {
  var adjustedMonth = month + 1;

  if (adjustedMonth < 10) {
    return "0".concat(adjustedMonth);
  }

  return "".concat(adjustedMonth);
};

export var toMonthlyEvents = function toMonthlyEvents(events, todaysDate) {
  var groupedEvents = events.reduce(function (acc, event) {
    var eventStartDate = new Date(event.startDate);
    var eventEndDate = new Date(event.endDate || event.startDate);

    if (eventEndDate >= todaysDate) {
      var firstDayOfMonth = eventStartDate <= todaysDate ? "".concat(eventEndDate.getFullYear(), "-").concat(getTwoDigitMonth(eventEndDate.getMonth()), "-01") : "".concat(eventStartDate.getFullYear(), "-").concat(getTwoDigitMonth(eventStartDate.getMonth()), "-01");

      if (!acc[firstDayOfMonth]) {
        acc[firstDayOfMonth] = [];
      }

      acc[firstDayOfMonth].push(toEventCard(event));
    }

    return acc;
  }, {});
  return Object.entries(groupedEvents).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        monthDate = _ref2[0],
        events = _ref2[1];

    events.sort(function (a, b) {
      return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    });
    return {
      monthDate: monthDate,
      events: events
    };
  }).sort(function (a, b) {
    return new Date(a.monthDate).getTime() - new Date(b.monthDate).getTime();
  });
};